import { combineReducers } from 'redux'
import declaration from './declaration'
import students from './students'

export default combineReducers({
  declaration,
  students,
})